import { SupportedTimeZones } from 'enums';
import { HALF_AN_HOUR_IN_MINUTES, HOUR_IN_MINUTES } from 'consts';
import {
  DATA_TZ_NAME_KEY,
  OPAQUE_OPACITY_VALUE,
  SELECTED_TIME_ZONE_OPACITY_COEFFICIENT,
} from './consts';

import type { TimeZonesMap } from 'types';

export const calcOpacityValueBasedOnOffset = (
  comparisonTimeZoneName: SupportedTimeZones,
  sourceTimeZoneName: SupportedTimeZones,
  matchedTzNamesWithOffset: TimeZonesMap
) => {
  const offsetValues = Object.values(matchedTzNamesWithOffset);
  const maxMatchingOffset = Math.max(...offsetValues);

  const comparisonOffset =
    matchedTzNamesWithOffset[comparisonTimeZoneName.toLowerCase()];
  const sourceOffset =
    matchedTzNamesWithOffset[sourceTimeZoneName.toLowerCase()];

  if (sourceOffset === comparisonOffset) {
    return OPAQUE_OPACITY_VALUE;
  }

  const maxPossibleStepsCount = maxMatchingOffset / HALF_AN_HOUR_IN_MINUTES;
  const step =
    (OPAQUE_OPACITY_VALUE / maxPossibleStepsCount) *
    SELECTED_TIME_ZONE_OPACITY_COEFFICIENT;

  const comparisonTzStepDistance = comparisonOffset / HALF_AN_HOUR_IN_MINUTES;

  return OPAQUE_OPACITY_VALUE - step * comparisonTzStepDistance;
};

export const getTimeZoneNodes = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>(`path[${DATA_TZ_NAME_KEY}]`)
  );

export const getWorkingDayOverlapHoursCountInfo = ({
  timeZoneName,
  matchedTzNamesWithOffset,
  workingDayLengthInMinutes,
}: {
  timeZoneName: SupportedTimeZones | null;
  matchedTzNamesWithOffset: TimeZonesMap | null;
  workingDayLengthInMinutes: number | null;
}) => {
  if (
    timeZoneName === null ||
    matchedTzNamesWithOffset === null ||
    workingDayLengthInMinutes === null ||
    matchedTzNamesWithOffset?.[timeZoneName.toLowerCase()] === undefined
  ) {
    return null;
  }

  return `${
    (workingDayLengthInMinutes -
      matchedTzNamesWithOffset[timeZoneName.toLowerCase()]) /
    HOUR_IN_MINUTES
  } hours overlap`;
};
